// extracted by mini-css-extract-plugin
export default {"imprint":"Imprint_imprint__i4EuT","link":"Imprint_link__QCI0J"};